import { Chess } from 'chess.js';
export function checkEndgameTransition(fenBefore, fenAfter) {
    const chessBefore = new Chess(fenBefore);
    const chessAfter = new Chess(fenAfter);
    const getMaterialWeight = (chess) => {
        let weight = 0;
        chess.board().flat().forEach(piece => {
            if (piece) {
                if (piece.type === 'q')
                    weight += 9;
                else if (piece.type === 'r')
                    weight += 5;
                else if (piece.type === 'b' || piece.type === 'n')
                    weight += 3;
            }
        });
        return weight;
    };
    const before = getMaterialWeight(chessBefore);
    const after = getMaterialWeight(chessAfter);
    // Endgame threshold: total material weight < 15 per side combined (approx)
    if (before >= 15 && after < 15) {
        return {
            id: 'endgame_transition',
            severity: 'low',
            data: { before, after }
        };
    }
    return null;
}
